module.exports = __webpack_public_path__ + "static/media/ind5kz.2ab47c7f.pdf";